import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { ASPECT_RATIO_OPTIONS } from 'consts'
import { ASPECT_RATIO_PER_TYPE } from 'containers/SubSidebar/AiImageContent/consts'
import { MediaStatus } from 'types/media'
import { projectDataThunks } from 'store/features/projectData/thunks'

export const useAspectRatioSwitch = () => {
  const { aspectRatioString } = useSelector(
    projectDataSelectors.defaultDimensions
  )
  const mediaItems = useSelector(projectDataSelectors.mediaItems)

  const hasPendingMedia = mediaItems.some(
    item => item.meta.status === MediaStatus.PENDING
  )

  const performSwitch = (key: 'landscape' | 'portrait') => {
    const dims = ASPECT_RATIO_OPTIONS[key]

    dispatch(
      projectDataThunks.setDefaultDimensions({
        width: dims.width,
        height: dims.height
      })
    )

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        dispatch(projectDataThunks.refitAllMediaToCanvas())
      })
    })
  }

  const getOppositeAspectRatio = (): 'landscape' | 'portrait' => {
    const isPortrait = aspectRatioString === ASPECT_RATIO_PER_TYPE.portrait
    const result = isPortrait ? 'landscape' : 'portrait'

    return result
  }

  const canSwitch = !hasPendingMedia

  return {
    aspectRatioString,
    hasPendingMedia,
    performSwitch,
    getOppositeAspectRatio,
    canSwitch
  }
}
